import userApi from "@/api/user";
import { keyBy } from "lodash";

const actions = {
  async load({ commit, state }) {
    commit("setUserListLoader", true);
    if (!state.userList.length && state.loadingPromise) {
      return state.loadingPromise;
    }
    state.loadingPromise = userApi
      .list()
      .then(userList => {
        commit("updateUserList", userList.data);
        commit("setUserListLoader", false);
      })
      .catch(e => {
        console.error(e);
        commit("setUserListLoader", false);
      });

    return state.loadingPromise;
  },
  async loadOchinUsers({ commit, state }) {
    commit("setOchinUserListLoader", true);
    if (!state.ochinUserList.length && state.loadingOchinUserPromise) {
      return state.loadingOchinUserPromise;
    }
    state.loadingOchinUserPromise = userApi
      .ochinList()
      .then(userList => {
        commit("updateOchinUserList", userList.data);
        commit("setOchinUserListLoader", false);
      })
      .catch(e => {
        console.error(e);
        commit("setOchinUserListLoader", false);
      });

    return state.loadingOchinUserPromise;
  },
};

const mutations = {
  setUserListLoader(state, isLoading) {
    state.isLoadingUserList = isLoading;
  },
  setOchinUserListLoader(state, isLoading) {
    state.isLoadingOchinUserList = isLoading;
  },
  updateUserList(state, userList) {
    state.userList = userList;
  },
  updateOchinUserList(state, userList) {
    state.ochinUserList = userList;
  },
};

const getters = {
  getUserMap: state => {
    return keyBy(state.userList, "username");
  },
  getOchinUserList: state => {
    return keyBy(state.ochinUserList, "username");
  },
};

const state = {
  isLoadingUserList: false,
  isLoadingOchinUserList: false,
  loadingPromise: null,
  loadingOchinUserPromise: null,
  userList: [],
  ochinUserList: [],
};

export default {
  actions,
  getters,
  mutations,
  namespaced: true,
  state,
};
